// frontend/src/pages/CustomerPayments.tsx
import React from 'react';

const CustomerPayments: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Payment & Billing</h1>
      <p>Payment methods and billing history.</p>
    </div>
  );
};

export default CustomerPayments;